import { FC } from 'react';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  return (
    <InnerWrapper>
      <GroupedDocsTable
        entityName="my-documents-trash"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'in_bin',
        }}
        hideActionsColumn
      />
    </InnerWrapper>
  );
};

export default Screen;
